// extracted by mini-css-extract-plugin
module.exports = {"Container":"Container_Container__1teMp","Content":"Container_Content__3Fw5N","main":"Container_main__2xP36"};